module.exports = __webpack_public_path__ + "static/img/start_icon.c1b2864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/start_icon.png
// module id = 516
// module chunks = 1 2 3 4 5 6